import { getUserId } from "../../lib/effectiveAuthUser";
import React, { useEffect, useState } from 'react';
import { db } from '../../Firebase.js';
import Auth from '../../Auth';
import { StyledContainer } from './styles';
import { useParams } from "react-router-dom";
import PageNotFound from '../../PageNotFound';
import Utils from '../../Utils';

export default function Bonus({
  subscription
}) {
  const { code } = useParams();

  const [bonus, setBonus] = useState(null);
  const [notFound, setNotFound] = useState(false);
  const [alreadyRedeemed, setAlreadyRedeemed] = useState(false);
  const [redeemed, setRedeemed] = useState(false);
  const [redeeming, setRedeeming] = useState(false);
  const [error, setError] = useState(null);

  useEffect(() => {
    async function get() {
      const results = await db.collection("bonuses").where("code", "==", code).get();

      if (results.docs[0]) {
        setBonus(results.docs[0]);

        const r = await db.collection("bonusRedemptions")
          .where("bonusId", "==", results.docs[0].id)
          .where("userId", "==", getUserId())
          .get();

        if (r.docs.length > 0) {
          setAlreadyRedeemed(true);
        }
      } else {
        setNotFound(true);
      }
    }


    if (!subscription.usesQuota) {
      setNotFound(true);
    } else {
      get();
    }


  }, []);

  return (
    <>
      {notFound &&
        <PageNotFound disableHeader={true} message="This page does not exist." />
      }
      {!notFound && bonus &&
        <StyledContainer>
          <div className="inner">
            <h1>{bonus.get('title')}</h1>
            <div>{Utils.nl2pRaw(bonus.get('description'))}</div>

            <div className="button-container">
              <button
                disabled={!subscription.activeSubscription || alreadyRedeemed || redeemed || redeeming}
                onClick={e => {
                  e.preventDefault();
                  setRedeeming(true);
                  Auth.fetchWithIdToken(`/api/bonus/${bonus.id}/redeem`, {}).then(res => {
                    setRedeeming(false);
                    if (res.success) {
                      setRedeemed(true);
                    } else {
                      setError("Something went wrong redeeming the bonus.");
                    }
                  });
                }}
              >
                Redeem {bonus.get('quota')} AI words
              </button>
            </div>

            {error &&
              <small className="error">{error}</small>
            }

            {redeemed &&
              <small>You have successfully redeemed this bonus!</small>
            }

            {!subscription.activeSubscription &&
              <small>You must have an active Sudowrite subscription in order to redeem bonuses.</small>
            }

            {alreadyRedeemed &&
              <small>You have already redeemed this bonus.</small>
            }
          </div>

        </StyledContainer>
      }
    </>
  );
}
